import script from "./open_source_cmp.vue?vue&type=script&setup=true&lang=js"
export * from "./open_source_cmp.vue?vue&type=script&setup=true&lang=js"

import "./open_source_cmp.vue?vue&type=style&index=0&id=048d8835&lang=less"

const __exports__ = script;

export default __exports__